import Vue from 'vue';
import App from './App.vue';
import router from './router';
import httpFactory from '@/utils/http';
import storeBuild from '@/utils/store';
import actionTool from '@/utils/action';
import plugins from '@/utils/plugins';
import LimitModal from './views/exam/components/LimitModal';

// 埋点
import webSee from '@yaww-websee/core';
Vue.use(webSee, {
  dsn: `https://${process.env.BUILD_ENV !== 'prod' ? 'dev-' : ''}i.yuaiweiwu.com/gs.gif`, // 上报的地址
  apply_id: 'netschool-pc', // 项目唯一的id
  repeatCodeError: true, // 开启错误上报去重，重复的代码错误只上报一次
  silentWhiteScreen: false, // 开启白屏检测
  client_type: 10, // 网校pc端
});

// sentry接入
import * as Sentry from '@sentry/vue';

if (process.env.BUILD_ENV && process.env.BUILD_ENV === 'prod') {
  Sentry.init({
    Vue,
    dsn: 'https://a3d099bfbcd4fe8ad5ef2db8ae36b0fd@sty.yuaiweiwu.com/8',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

Vue.config.bjy_player = null;

import '../../utils/extension';
import '../../utils/filter';
import '../../utils/highlight';
import './video';
import ServiceInject from '@/services/ServiceInject';
import lang from '../../lang';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
Vue.component('LimitModal', LimitModal);
Vue.prototype.$actionTool = { ...actionTool, ...plugins };
const i18n = new VueI18n({
  locale: 'cn',
  messages: lang.message,
});

Vue.config.productionTip = false;
Vue.config.login_flag = false;
Vue.config.school_flag = false;

import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
Vue.use(VueAwesomeSwiper);

import ScaleImage from '@/components/ScaleImage.vue';
Vue.component('ScaleImage', ScaleImage);

import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload);

import ImageClip from '@/components/ImageClip.vue';
Vue.component('ImageClip', ImageClip);

let vue;
const http = httpFactory.build('student');
Vue.prototype.$http = http;
http.beforeRequest = function (isAuthRequest, showLoading) {
  if (isAuthRequest) {
    if (!store.state.token) {
      router.push({
        name: 'Login',
      });
      return false;
    }
  }
  if (showLoading) {
    store.commit('setLoading', true);
  }
  return true;
};
http.afterRequest = function () {
  store.commit('setLoading', false);
};
http.onApiError = function (data) {
  if (data.code == 202) {
    if (!Vue.config.login_flag) {
      Vue.config.login_flag = true;
      vue.$error(data.msg).then(() => {
        store.commit('logout');
        store.commit('clearSchoolInfo');
        router.push({
          name: 'Login',
        });
        Vue.config.login_flag = false;
      });
    }
  } else if (data.code == 205) {
    if (!Vue.config.school_flag) {
      Vue.config.school_flag = true;
      vue
        .$alert(data.msg, {
          showClose: false,
        })
        .then(() => {
          Vue.config.school_flag = false;
          store.commit('setSchoolID', store.state.user_info.origin_school_id);
          window.location.href = '/';
        });
    }
  } else if (data.msg == '你来晚了哦,名额已经没有了~') {
    vue.$alert(data.msg, '提示');
  } else {
    vue.$message.error(data.msg);
  }
};

const store = storeBuild(http, 'student', async (context) => {
  if (!context.state.token) {
    return;
  }
  let data = await http.get('/api/app/userInfo');
  data.sex = data.sex.toString();
  context.commit('setUser', data);
});

// 发送埋点
Vue.prototype.$webSeeSendTrack = (trackParams) => {
  const user_info = store.state.user_info;
  webSee.log({
    event_id: trackParams.event_id,
    event_type:
      trackParams.event_type === 'click'
        ? webSee.EVENTTYPES.MODULE_CLICK
        : webSee.EVENTTYPES.PAGE_SHOW,
    data: {
      ...{ userId: user_info.id, mobile: user_info.mobile, nickname: user_info.nickname },
      ...(trackParams.data || {}),
    },
  });
};

// identity
import Identity from '@/utils/identity';
Vue.prototype.$identity = new Identity('student', store.state);

async function refreshSetting(routeTo) {
  if (routeTo.name != 'Login' && !store.state.school_info.cur_school_id) {
    await store.dispatch('getSchoolInfo');
  }
  if (store.state.webConfig.web_title) {
    document.title = plugins.getTitle(store.state.webConfig.web_title, routeTo);
  } else {
    await store.dispatch('getWebConfig', routeTo);
    await store.dispatch('getOtherSetting');
  }
}

router.beforeEach(async (to, from, next) => {
  let schoolId = to.query.school_id;
  //如果跳转到vip页面，但是会员关闭
  if (to.name == 'Vip') {
    await store.dispatch('getWebConfig', to);
    if (!store.getters.showVip)
      next({
        name: 'Index',
      });
  }
  // 解决离开播放页，视频依然在播放的问题
  if (from.name == 'Video') {
    if (Vue.config.bjy_player && Vue.config.bjy_player.duration) {
      Vue.config.bjy_player.pause();
      Vue.config.bjy_player.destroy();
      window.$('#video-wrap').html('');
    }
  }
  if (schoolId) {
    store.commit('setSchoolID', schoolId);
    let query = { ...to.query };
    delete query.school_id;
    let { href } = router.resolve({ name: to.name, params: to.params, query });
    window.location = href;
    return;
  }
  if (to.name == 'Index') {
    await refreshSetting(to);
    await store.dispatch('getIndexData');
    let indexData = store.state.indexData;
    if (indexData.bannerList.length == 0 && indexData.recommendList.length == 0) {
      let navigate = store.state.navigates[0];
      if (navigate && navigate.is_outer == 0) {
        let url = navigate.url;
        if (url == '/index') {
          next();
          return;
        }
        if (url.indexOf('?') < 0) {
          url += '?';
        } else {
          url += '&';
        }
        url += 'nav=' + navigate.id;
        router.push({ path: url });
        return;
      }
    }
  }
  if (from.name != 'ForgotPassword' && from.name != 'Login') {
    to.query.relogin = from.name;
  } else {
    to.query.relogin = '';
  }
  await refreshSetting(to);

  if (to.meta.requireAuth) {
    // 老师通过分享的作业详情页面默认不校验登录逻辑
    const isShareHomeworkIntor = to.name === 'HomeworkIntro' && to.query.share;
    if (store.state.token || isShareHomeworkIntor) {
      next();
    } else {
      next({
        name: 'Login',
        query: {
          relogin: 1,
        },
      });
    }
  } else {
    next();
  }
  window.scrollTo(0, 0);
});
// Vue.prototype.$store = store;
vue = new Vue({
  router,
  store: store,
  i18n,
  render: (h) => h(App),
});

ServiceInject(http, vue, store, router);
//action中传入vue实例
import { use as actionUse } from '@/utils/action.js';
actionUse(vue);
vue.$mount('#app');
